import Vue from 'vue';

import { SAVE_CHAT_ANSWERS, SAVE_PROPOSAL } from './mutation-types';


export default {
  launchCampaign: async ({ commit }, chatAnswers) => {
    try {
      const res = await axios.post('/campaigns', {
        updated_by: 'user',
        chat_answers: chatAnswers
      });
      commit(SAVE_CHAT_ANSWERS, chatAnswers);
      commit(SAVE_PROPOSAL, res.data.proposal);
    } catch (error) {
      console.error(error);
    }
 }
};
